if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');

            // subscription switch events
              const sellingOptions = document.getElementsByName("selling_options");
              const sellingPlansEl = document.querySelector("select[name='selling_plan']")
              const product_form = document.querySelector('product-info product-form form');

              for (let i = 0; i < sellingOptions.length; i++) {
                sellingOptions[i].addEventListener('change', function() {
                  var parentWidget = this.closest('[data-js-widget]');
                  if (!parentWidget) return;

                  document.querySelectorAll('[data-js-widget]').forEach(function(widget) {
                      widget.classList.remove('active');
                  });
                  if (this.checked) {
                    parentWidget.classList.add('active');
                  }

                  if(product_form) {
                    const qtySelect = parentWidget.querySelector('select[data-qty-select]');
                    if (qtySelect) {
                      qtySelect.value = 1;
                      qtySelect.dispatchEvent(new Event('change', { bubbles: true }));
                    }

                    const originSelect = parentWidget.querySelector('.origin[data-var-index="0"] select');
                    if (originSelect) {
                      originSelect.selectedIndex = 0;
                      originSelect.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                  }

                  const defaultVariant = parentWidget.parentElement
                    ? parentWidget.parentElement.getAttribute('data-default-variant')
                    : null;
                  const subscribes = parentWidget.hasAttribute('data-option-subsave');
                  const planForLines = subscribes && sellingPlansEl ? sellingPlansEl.value : '';

                  writeCartLineInputs(
                    product_form,
                    buildCartLineInputs([defaultVariant], planForLines)
                  );
                });
              }

              if(sellingPlansEl) {
                sellingPlansEl.addEventListener('change', function() {
                    // Get the selected value
                    let selectedValue = this.value;

                    if(sellingPlansEl.closest('[data-js-widget]').classList.contains('active')){
                      // sellingPlansEl.closest('product-info').querySelector("input[name='selling_plan']").value = selectedValue

                      if(sellingPlansEl.closest('product-info').querySelectorAll(".sellingPlan").length){
                        sellingPlansEl.closest('product-info').querySelectorAll(".sellingPlan").forEach(function(sellingInput){
                          sellingInput.value = selectedValue
                        })
                      }
                    }
                });
              }

              // selling plan qty switch dropdown logic
              const qtySelects = document.querySelectorAll('[data-subscription-widget] [data-qty-select]');
            
              if(qtySelects.length) {
                // Loop through each select element
                qtySelects.forEach(qtySelect => {
                    // Add onchange event listener to each select element
                    qtySelect.addEventListener('change', function() {
                        // Get the selected quantity
                        const selectedQty = parseInt(this.value);

                        // Find the parent element with the attribute 'data-js-widget'
                        const parentElement = this.closest('[data-js-widget]');

                        if(parentElement.classList.contains('active')) {
                          // Get all origin blocks within the parent element
                          const originBlocks = parentElement.querySelectorAll('.origin');

                          // Loop through each origin block
                          originBlocks.forEach((block, index) => {
                              // Show or hide origin block based on selected quantity
                              if (index < selectedQty) {
                                  block.classList.remove('hidden');
                              } else {
                                  block.classList.add('hidden');
                              }
                          });

                          // now append items id in dom dynamically based on qty

                          if(product_form) {
                            const currentSellingPlan = parentElement.querySelector("select[name='selling_plan']");
                            const currentSellingPlanVal = currentSellingPlan ? currentSellingPlan.value : '';

                            const masterIdEl = product_form.querySelector('.product-variant-id');

                            if(masterIdEl) {
                              masterIdEl.remove()
                            }

                            // price update in cta based on cta
                            const priceEl = product_form.querySelector('.product_dynamic-pricing');
                            const main_price = document.querySelector('.product__info-wrapper .price__regular .price-item')

                            if(priceEl && parentElement.classList.contains('active')) {
                              priceEl.innerHTML = formatMoney(parseInt(parentElement.getAttribute('data-price')) * selectedQty ,window.moneyFormat);
                            }

                            if(main_price) {
                              main_price.innerHTML = formatMoney(parseInt(parentElement.getAttribute('data-price')) * selectedQty ,window.moneyFormat)
                            }

                            // One line item per bottle, using whatever origin each dropdown shows.
                            const planForLines = parentElement.hasAttribute('data-option-onetime')
                              ? ''
                              : currentSellingPlanVal;

                            writeCartLineInputs(
                              product_form,
                              buildCartLineInputs(widgetVariantIds(parentElement, selectedQty), planForLines)
                            );
                          }
                          
                        }
                    });
                });
              }

              const variantIdSelector = document.querySelectorAll('[data-subscription-widget] .origin');

              if(variantIdSelector.length) {
                variantIdSelector.forEach(function(origin){
                  const originSelect = origin.querySelector('select');
                  if (!originSelect) return;

                  originSelect.addEventListener('change',function(e){
                    const host = product_form ? product_form.querySelector('.js-inputs-ids') : null;
                    const varIndex = e.target.parentElement
                      ? e.target.parentElement.getAttribute('data-var-index')
                      : null;
                    if (!host || varIndex === null) return;

                    const idInput = host.querySelector(`[name="items[${varIndex}][id]"]`);
                    if (idInput) idInput.value = e.target.value;
                  })
                })
              }
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
